import moment from 'moment'
import store from '@/plugins/store/index.js'

const formatDateGregorian = function (value) {
	const defaultLanguage = store.getters['user/language']
	if (!value) return ''
	return moment(value).locale(defaultLanguage).format('YYYY-MM-DD')
}

const formatDateTimeGregorian = function (value) {

	const defaultLanguage = store.getters['user/language']

	if (!value) return ''
	return defaultLanguage == 'ar'
		? moment(value).format('HH:mm:ss ,YYYY-MM-DD')
		: moment(value).format('YYYY-MM-DD, HH:mm:ss')
}


export { formatDateGregorian, formatDateTimeGregorian }